import { AzureDataBricksLinkedService } from './../../linkedservice/azure-data-bricks.linkedservice';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ReferenceAdapter } from '../reference.adapter';
import { ValueAdapter } from '../value.adapter';
import _ from 'lodash';
import { JobActivity } from 'app/model/pipeline/job.activity';
import { convertParametersToModel } from 'app/shared/utils/parameter-converter.util';
import { ParameterConfigString } from 'app/model/pipeline/parameter-config-string';
import { toParameterClass, toParameterObject } from 'app/model/adapters/linkedservices/parameter-config-string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JobActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            jobId: '*',
            jobParameters: '*'
        }
    }
})
export class JobActivityAdapter extends ActivityAsyncAdapter<JobActivity, Model.DatabricksJobyActivity> {

    public model(): IModel {
        return Metamodel.modelFor(JobActivity);
    }

    protected async _toResource(activity: JobActivity): Promise<Model.DatabricksJobyActivity> {
        const resource: Model.DatabricksJobyActivity = super._getCommonActivityProperties(activity, Metamodel.modelFor(JobActivity).name) as Model.DatabricksJobyActivity;

        resource.typeProperties = {
            jobId: ValueAdapter.toResource(activity, JobActivity.JOBID),
            jobParameters: toParameterObject(activity.jobParameters as ParameterConfigString[]),
        };

        if (activity.linkedService) {
            resource.linkedServiceName = this._toLinkedServiceReferenceModel(activity.linkedService, activity.linkedServiceParameters);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(resource, parsed);
        }

        return resource;
    }

    protected async _toModel(modelActivity: Model.DatabricksJobyActivity): Promise<JobActivity> {
        const activity: JobActivity = new JobActivity(modelActivity.name);
        const resource = modelActivity as Model.DatabricksJobyActivity;

        this._updatedCommonProperties(modelActivity, activity);

        if (resource.typeProperties) {
            ValueAdapter.toModel(activity, JobActivity.JOBID, resource.typeProperties.jobId);
            activity.jobParameters = toParameterClass(modelActivity.typeProperties.jobParameters, activity);
        }

        if (resource.linkedServiceName != null) {
            activity.linkedService = ReferenceAdapter.toProxyModel<AzureDataBricksLinkedService>(Metamodel.modelFor(AzureDataBricksLinkedService),
                resource.linkedServiceName, this.context);
            if (resource.linkedServiceName.parameters) {
                // Parameter value for linked service
                convertParametersToModel(activity,
                    !!this.context.adapterConfig.replaceIdentitiesForNonConcepts,
                    activity.linkedService,
                    activity.linkedServiceParameters,
                    resource.linkedServiceName.parameters);
            }
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, resource, JobActivity.MODEL));

        return activity;
    }
}
